import type { XAXisComponentOption, YAXisComponentOption } from 'echarts';
import { BarChart, LineChart, type BarSeriesOption, type LineSeriesOption } from 'echarts/charts';
import {
  AxisPointerComponent, DataZoomComponent, GridComponent, MarkAreaComponent, MarkLineComponent, MarkPointComponent,
  ToolboxComponent, TooltipComponent,
  type AxisPointerComponentOption, type DataZoomComponentOption, type GridComponentOption,
  type MarkAreaComponentOption, type MarkLineComponentOption, type MarkPointComponentOption,
  type ToolboxComponentOption, type TooltipComponentOption,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart, LineChart, AxisPointerComponent, DataZoomComponent, GridComponent, MarkAreaComponent,
  MarkLineComponent, MarkPointComponent, ToolboxComponent, TooltipComponent, CanvasRenderer,
]);

export { echarts };
export type EChartsType = echarts.EChartsType;
export type ECOption = echarts.ComposeOption<
  | BarSeriesOption | LineSeriesOption | AxisPointerComponentOption | DataZoomComponentOption | GridComponentOption
  | MarkAreaComponentOption | MarkLineComponentOption | MarkPointComponentOption | ToolboxComponentOption
  | TooltipComponentOption | XAXisComponentOption | YAXisComponentOption
>;
export type {
  BarSeriesOption, GridComponentOption, LineSeriesOption, TooltipComponentOption, XAXisComponentOption, YAXisComponentOption,
};
